import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerFooter,
  Button,
} from '@one-thd/sui-atomic-components';
import AcknowledgementList from './AcknowledgementList';

interface TermsAndConditionsDrawerProps {
  displayDrawer: boolean;
  closeDrawer: () => void;
  acceptTerms: () => void;
}

const TermsAndConditionsDrawer = ({
  displayDrawer,
  closeDrawer,
  acceptTerms,
}: TermsAndConditionsDrawerProps) => {
  const handleAcknowledge = () => {
    acceptTerms();
    closeDrawer();
  };
  return (
    <div className="sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96">
      <Drawer
        open={displayDrawer}
        onClose={closeDrawer}
        position="right"
        className="drawer-z-index-fix"
      >
        <DrawerHeader title="Terms and Conditions" onClose={closeDrawer} />
        <DrawerBody>
          <AcknowledgementList />
        </DrawerBody>
        <DrawerFooter className="sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky sui-shadow-sm">
          <div className="sui-flex sui-gap-4 sui-flex-col">
            <Button fullWidth onClick={handleAcknowledge}>
              Acknowledge Terms and Conditions
            </Button>
            <Button fullWidth variant="secondary" onClick={closeDrawer}>
              Cancel
            </Button>
          </div>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};

export default TermsAndConditionsDrawer;
